module.exports = __webpack_public_path__ + "static/img/dialog-bg1.a8d3011e.png";